import config from '../config/config.json'
import superagent from 'superagent'

const GET_ADMIN_USERID_REQUEST = 'GET_ADMIN_USERID_REQUEST'
const GET_ADMIN_USERID_SUCCESS = 'GET_ADMIN_USERID_SUCCESS'
const GET_ADMIN_USERID_FAILURE = 'GET_ADMIN_USERID_FAILURE'
const ADMIN_GET_STUDENT_SUBMISSIONS_REQUEST = 'ADMIN_GET_STUDENT_SUBMISSIONS_REQUEST'
const ADMIN_GET_STUDENT_SUBMISSIONS_FAILURE = 'ADMIN_GET_STUDENT_SUBMISSIONS_FAILURE'
const ADMIN_GET_STUDENT_SUBMISSIONS_SUCCESS = 'ADMIN_GET_STUDENT_SUBMISSIONS_SUCCESS'
const ADMIN_GET_EDITOR_ASSIGNMENTS_REQUEST = 'ADMIN_GET_EDITOR_ASSIGNMENTS_REQUEST'
const ADMIN_GET_EDITOR_ASSIGNMENTS_FAILURE = 'ADMIN_GET_EDITOR_ASSIGNMENTS_FAILURE'
const ADMIN_GET_EDITOR_ASSIGNMENTS_SUCCESS = 'ADMIN_GET_EDITOR_ASSIGNMENTS_SUCCESS'

export {
  GET_ADMIN_USERID_REQUEST,
  GET_ADMIN_USERID_SUCCESS,
  GET_ADMIN_USERID_FAILURE,
  ADMIN_GET_STUDENT_SUBMISSIONS_REQUEST,
  ADMIN_GET_STUDENT_SUBMISSIONS_FAILURE,
  ADMIN_GET_STUDENT_SUBMISSIONS_SUCCESS,
  ADMIN_GET_EDITOR_ASSIGNMENTS_REQUEST,
  ADMIN_GET_EDITOR_ASSIGNMENTS_FAILURE,
  ADMIN_GET_EDITOR_ASSIGNMENTS_SUCCESS
}

export function getAdminUserIdRequest() {
  return {
    type: GET_ADMIN_USERID_REQUEST,
    loading: true
  }
}

export function getAdminUserIdSuccess(body) {
  return {
    type: GET_ADMIN_USERID_SUCCESS,
    body: body,
    loading: false
  }
}

export function getAdminUserIdFailure(error) {
  return {
    type: GET_ADMIN_USERID_FAILURE,
    error: error,
    loading: false
  }
}
export function getStudentDocumentsRequest() {
  return {
    type: ADMIN_GET_STUDENT_SUBMISSIONS_REQUEST,
    loading: true
  }
}

export function getStudentDocumentsSuccess(body) {
  return {
    type: ADMIN_GET_STUDENT_SUBMISSIONS_SUCCESS,
    body: body,
    loading: false
  }
}

export function getStudentDocumentsFailure(error) {
  return {
    type: ADMIN_GET_STUDENT_SUBMISSIONS_FAILURE,
    error: error,
    loading: false
  }
}

export function getAdminUserId(UserId, cb) {
  return function(dispatch) {
    console.log('---- inside get admin user id ----');
    console.log('---- inside get admin user id ----');
    console.log(UserId);
    dispatch(getAdminUserIdRequest())
    superagent
    .get(config.BASE + 'api/admin/user/' + UserId)
    .withCredentials()
    .end((err, res) => {
      if (err) {
        // alert(JSON.stringify(err.response.body.message))
        dispatch(getAdminUserIdFailure(err))
      } else {
        dispatch(getAdminUserIdSuccess(res.body))
        if (cb) {
          cb(res.body)
        }
      }
    })
  }
}
export function getStudentDocuments(userId, page, cb) {
  var pager = '';
  if(page) {
    pager = '&page='+page;
  }
  return function(dispatch) {
    dispatch(getStudentDocumentsRequest())
    superagent
    .get(config.BASE + 'api/admin/submissions?userId=' + userId+pager)
    .withCredentials()
    .end((err, res) => {
      if (err) {
        // alert(JSON.stringify(err.response.body.message))
        dispatch(getStudentDocumentsFailure(err))
      } else {
        dispatch(getStudentDocumentsSuccess(res.body))
        if (cb) {
          cb(res.body)
        }
      }
    })
  }
}

const UPDATE_ADMINUSERID_INPUT = 'UPDATE_ADMINUSERID_INPUT'

export { UPDATE_ADMINUSERID_INPUT }

export function updateAdminUserIdInput(key, value) {
  return {
    type: UPDATE_ADMINUSERID_INPUT,
    key: key,
    value: value
  }
}

const PATCH_ADMIN_USERID_REQUEST = 'PATCH_ADMIN_USERID_REQUEST'
const PATCH_ADMIN_USERID_SUCCESS = 'PATCH_ADMIN_USERID_SUCCESS'
const PATCH_ADMIN_USERID_FAILURE = 'PATCH_ADMIN_USERID_FAILURE'

export {
  PATCH_ADMIN_USERID_REQUEST,
  PATCH_ADMIN_USERID_SUCCESS,
  PATCH_ADMIN_USERID_FAILURE
}

export function patchAdminUserIdRequest() {
  return {
    type: PATCH_ADMIN_USERID_REQUEST,
    loading: true
  }
}

export function patchAdminUserIdSuccess(body) {
  return {
    type: PATCH_ADMIN_USERID_SUCCESS,
    body: body,
    loading: false
  }
}

export function patchAdminUserIdFailure(error) {
  return {
    type: PATCH_ADMIN_USERID_FAILURE,
    error: error,
    loading: false
  }
}

export function patchAdminUserId(body, UserId, cb) {
  return function(dispatch) {
    dispatch(patchAdminUserIdRequest())
    superagent
    .put(config.BASE + 'api/admin/user/' + UserId)
    .send(body)
    .withCredentials()
    .end((err, res) => {
      if (err) {
        // alert("Could not update user!")
        dispatch(patchAdminUserIdFailure(err))
      } else {
        // alert("User updated!")
        dispatch(patchAdminUserIdSuccess(res.body))
        if (cb) {
          cb(res.body)
        }
      }
    })
  }
}

export function getEditorsAssignmentsRequest() {
  return {
    type: ADMIN_GET_EDITOR_ASSIGNMENTS_REQUEST,
    loading: true
  }
}

export function getEditorsAssignmentsSuccess(body) {
  return {
    type: ADMIN_GET_EDITOR_ASSIGNMENTS_SUCCESS,
    body: body,
    loading: false
  }
}

export function getEditorsAssignmentsFailure(error) {
  return {
    type: ADMIN_GET_EDITOR_ASSIGNMENTS_FAILURE,
    error: error,
    loading: false
  }
}

export function getEditorsAssignments(userId, page, cb) {
  var pager = '';
  if(page) {
    pager = '&page='+page;
  }
  return function(dispatch) {
    dispatch(getEditorsAssignmentsRequest())
    superagent
    .get(config.BASE + 'api/admin/edits?userId=' + userId+pager)
    .withCredentials()
    .end((err, res) => {
      if (err) {
        // alert(JSON.stringify(err.response.body.message))
        dispatch(getEditorsAssignmentsFailure(err))
      } else {
        dispatch(getEditorsAssignmentsSuccess(res.body))
        if (cb) {
          cb(res.body)
        }
      }
    })
  }
}


// WEBPACK FOOTER //
// ./src/actions/AdminUserId.js